import { BUTTON_KIND, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons/types'
import Button from 'parkdepot-shared/components/Buttons/Button'
import React, { SyntheticEvent, useState } from 'react'
import VoucherDrawer from './VoucherDrawer.component'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { B2COrderResponseFragment } from 'parkdepot-shared/gql/graphql'

const Voucher = ({ orderData, disabled }: { orderData: B2COrderResponseFragment; disabled: boolean }) => {
    const { search } = useLocation()
    const { t } = useTranslation()
    const [voucherModalOpen, setVoucherModalOpen] = useState(() => {
        if (disabled) return false

        let couponCode = new URLSearchParams(search).get('c')
        // couponCode is base64 encoded and might contain of '+' and '/'.
        // Since '+' is replaced to ' ' in URLSearchParams.get we have to replace it back.
        // We have to do nothing with '/'
        couponCode = couponCode ? couponCode.replace(/ /g, '+') : ''

        return !!couponCode
    })

    const handleApplyButtonClick = (e: SyntheticEvent<HTMLButtonElement>) => {
        e.preventDefault()

        setVoucherModalOpen(true)
    }

    return (
        <>
            {!disabled ? (
                <Button
                    id="apply-code-button"
                    data-testid="apply-voucher-button"
                    onClick={handleApplyButtonClick}
                    $kind={BUTTON_KIND.secondary}
                    $size={BUTTON_SIZE.medium}
                >
                    {t('carpay.voucher.apply')}
                </Button>
            ) : null}

            <VoucherDrawer
                orderData={orderData}
                isOpen={voucherModalOpen}
                disabled={disabled}
                onClose={() => setVoucherModalOpen(false)}
            />
        </>
    )
}

export default Voucher
